var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Algeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,4v40c11.046,0,20-8.954,20-20C44,12.954,35.046,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M4,24c0,11.046,8.954,20,20,20V4C12.954,4,4,12.954,4,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M30.734,20c-2.211-3.824-7.102-5.137-10.926-2.926c-3.828,2.207-5.137,7.102-2.93,10.926 s7.102,5.137,10.926,2.926c1.215-0.699,2.227-1.711,2.93-2.926c-2.211,2.758-6.238,3.203-8.996,0.996 c-2.758-2.211-3.203-6.238-0.996-8.996c2.211-2.758,6.238-3.203,8.996-0.996C30.105,19.301,30.437,19.633,30.734,20 M31.199,24.215 L24,21.867L28.48,28v-7.57L24,26.559L31.199,24.215z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Algeria);
export default __webpack_public_path__ + "static/media/icons8-algeria.41010624b36147be06c47e7f3b146047.svg";
export { ForwardRef as ReactComponent };